export const model = {
    id: null,
    name: '',
    room_number: '',
    created_at: "",
    updated_at: ''
};
